const GENERIC_STATUS_MESSAGE = /^Request failed with status code \d+$/i;

const collectApiValidationMessages = (errors: Record<string, unknown>): string[] => {
  const messages: string[] = [];
  for (const value of Object.values(errors)) {
    if (Array.isArray(value)) {
      for (const item of value) {
        if (typeof item === 'string' && item.trim()) {
          messages.push(item);
        }
      }
    } else if (typeof value === 'string' && value.trim()) {
      messages.push(value);
    }
  }
  return messages;
};

const messageFromData = (data: unknown): string | undefined => {
  if (data == null) return undefined;

  if (Array.isArray(data)) {
    const joined = data
      .map((item) => (item && typeof item === 'object' ? (item as {message?: string}).message : undefined))
      .filter((message): message is string => Boolean(message?.trim()))
      .join('\n');
    return joined || undefined;
  }

  if (typeof data === 'string' && data.trim()) {
    return data;
  }

  if (typeof data !== 'object') return undefined;

  const body = data as {
    message?: string;
    detail?: string;
    title?: string;
    errors?: Record<string, unknown>;
  };

  if (typeof body.message === 'string' && body.message.trim()) return body.message;
  if (typeof body.detail === 'string' && body.detail.trim()) return body.detail;

  if (body.errors && typeof body.errors === 'object') {
    const validationMessages = collectApiValidationMessages(body.errors);
    if (validationMessages.length) return validationMessages.join('\n');
  }

  if (typeof body.title === 'string' && body.title.trim()) return body.title;

  return undefined;
};

export const getHttpErrorMessage = (error: unknown, fallback: string): string => {
  if (error == null) return fallback;

  const err = error as {
    message?: string;
    data?: unknown;
    response?: {data?: unknown; body?: {message?: string; detail?: string}};
  };

  const fromData =
    messageFromData(err.data) ||
    messageFromData(err.response?.data) ||
    err.response?.body?.message ||
    err.response?.body?.detail;

  if (fromData) return fromData;

  if (typeof err.message === 'string' && err.message.trim() && !GENERIC_STATUS_MESSAGE.test(err.message)) {
    return err.message;
  }

  return fallback;
};
